export const keyToken = 'token';
export const keyEmail = 'email';
export const keyPassword = 'password';
